(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/data/resyncs', {
      templateUrl: 'modules/app/data/resyncs/resyncs.html',
      controller: 'ResyncTasksCtrl',
      requiredPermissions: ['admin']
    });
  }]).controller('ResyncTasksCtrl', ['$scope', '$controller', '$location', '$http', '$uibModal', 'Alerts', 'Api', 'User', 'UserRoles', '$filter', 'ResyncsService', function ($scope, $controller, $location, $http, $uibModal, Alerts, Api, User, UserRoles, $filter, ResyncsService) {
    if (!UserRoles.isSystemAdmin(User.get())) {
      $location.path('/');
    }
    $scope.section = "resyncs";
    $scope.isLoading = {
      query: true,
      page: true
    };
    $scope.searchQuery = '';
    $scope.statuses = ['All', 'Queued', 'Submitted', 'Running', 'Completed', 'Failed'];
    $scope.selectedStatus = 'All';
    $scope.selectedSource = 'All';
    $scope.inputPlaceholder = function () {
      return $scope.selectedSource === "Statement Import" ? "Search for Statement Import ID" : null;
    };
    $scope.selectStatus = function (status) {
      $scope.selectedStatus = status;
      $scope.setPage(1);
    };
    $scope.selectSource = function (source) {
      if ($scope.selectedSource !== source) {
        $scope.searchQuery = '';
      }
      $scope.selectedSource = source;
      $scope.setPage(1);
    };
    $scope.sortBy = "-created";
    $scope.sortControls = [{
      "title": "Task ID"
    }, {
      "title": "Created",
      "options": {
        "Ascending": "created",
        "Descending": "-created"
      }
    }, {
      "title": "Entity"
    }, {
      "title": "Updated",
      "options": {
        "Ascending": "updatedStatements",
        "Descending": "-updatedStatements"
      }
    }, {
      "title": "Total",
      "options": {
        "Ascending": "totalStatements",
        "Descending": "-totalStatements"
      }
    }, {
      "title": "Run Time",
      "options": {
        "Ascending": "runningTime",
        "Descending": "-runningTime"
      }
    }, {
      "title": "Source"
    }, {
      "title": "Status"
    }];
    $scope.setSort = function (sort) {
      $scope.sortBy = sort;
      $scope.isLoading.page = true;
      $scope.setPage(1);
    };
    $scope.getSortDirection = function getSortDirection(control) {
      if (control && control.options) {
        var containsExactMatch = _.contains(control.options, $scope.sortBy);
        if (containsExactMatch) {
          return $scope.sortBy.charAt(0) === '-' ? "down" : "up";
        }
      }
    };
    var debouncedSearch = _.debounce(function () {
      $scope.setPage(1);
    }, 1000);
    $scope.onQueryChange = function () {
      $scope.isLoading.query = true;
      debouncedSearch();
    };
    $scope.showEventInfo = function (event) {
      try {
        $scope.eventInfo = JSON.stringify(event, null, 2);
      } catch (e) {
        $scope.eventInfo = event;
      }
      $scope.showEventModal = $uibModal.open({
        templateUrl: 'modules/app/data/resyncs/event-modal.html',
        controller: 'RowDetailModalCtrl',
        backdrop: 'static',
        size: 'lg',
        scope: $scope
      });
    };
    $scope.resyncLock = false;
    $scope.resyncLockLoading = false;
    $scope.getFullTextSpan = function (fullText) {
      var span = $filter('chunkify')(fullText);
      return "<span><strong>Full Entity Name:</strong></span>".concat(span);
    };
    $scope.popoverText = function (task) {
      return "\n                    <div class=\"popover-grid\">\n                        <span><strong>Task ID:</strong></span>\n                        <span>".concat(task.taskId, "</span>\n                        ").concat(task.entity.length > 40 ? $scope.getFullTextSpan(task.entity) : '', "\n                    </div>\n                ");
    };
    var user = User.get();
    var orgId = user.organization && user.organization.id;
    $scope.search = function () {
      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
      var source = $scope.selectedSource.toLowerCase() !== 'all' ? $scope.selectedSource + ' ' + $scope.searchQuery : null;
      var status = $scope.selectedStatus.toLowerCase() === 'all' ? null : $scope.selectedStatus.toLowerCase();
      return ResyncsService.getResyncTasks(source, status, limit, offset, $scope.sortBy).then(function (results) {
        return results.data;
      }).finally(function () {
        $scope.isLoading.query = false;
        $scope.isLoading.page = false;
      });
    };
    $scope.queueResyncTask = function (task) {
      task.status = 'submitted';
      ResyncsService.updateResyncTask(task).then(function (r) {
        task.status = r.data.status;
      }).catch(function (e) {
        task.status = 'failed';
        Alerts.raiseAlert({
          "type": "danger",
          "text": "There was an error queueing the event:\n" + e.data.message,
          "autoDismiss": true,
          "autoDismissTimeout": 2500
        });
      });
    };
    $scope.refreshResyncLock = function () {
      $scope.resyncLockLoading = true;
      ResyncsService.refreshResyncLock(orgId).then(function (r) {
        var data = r.data;
        $scope.resyncLock = data.resyncLock !== undefined;
        $scope.resyncLockLoading = false;
        if ($scope.resyncLock) {
          $scope.resyncLockData = JSON.stringify(JSON.parse(data.resyncLock), null, 2);
        }
      });
    };
    $scope.freeResyncLock = function () {
      $scope.resyncLockLoading = true;
      ResyncsService.freeResyncLock(orgId).then(function () {
        $scope.resyncLock = false;
        $scope.resyncLockLoading = false;
      });
    };
    $scope.refreshResyncLock();
    $scope.onPagerLoad = function () {
      $scope.setPage(1);
    };
  }]);
})();
